"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_leaflet_1 = require("react-leaflet");
var zoom_control_component_1 = __importDefault(require("./zoom-control.component"));
var AddOutline_1 = __importDefault(require("../../icons/generated/AddOutline"));
var RemoveOutline_1 = __importDefault(require("../../icons/generated/RemoveOutline"));
var styled_components_1 = __importDefault(require("styled-components"));
var lodash_1 = __importDefault(require("lodash"));
var ZoomControls = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 60px;\n  right: 30px;\n  z-index: 1000;\n\n  display: inline-flex;\n  flex-direction: column;\n  font-size: 30px;\n  color: ", "\n  cursor: pointer;  \n  border: 1px solid ", ";\n\n  div {\n    display: flex;    \n    height: 32px;\n    width: 32px;\n    justify-content: center;\n    align-items: center;\n\n    &:last-of-type {\n      border-top: 1px solid ", ";\n    }\n\n    &:hover {\n      background: ", ";\n      cursor: pointer;\n    }\n\n    &:active {\n      background: ", ";\n    }\n"], ["\n  position: absolute;\n  bottom: 60px;\n  right: 30px;\n  z-index: 1000;\n\n  display: inline-flex;\n  flex-direction: column;\n  font-size: 30px;\n  color: ", "\n  cursor: pointer;  \n  border: 1px solid ", ";\n\n  div {\n    display: flex;    \n    height: 32px;\n    width: 32px;\n    justify-content: center;\n    align-items: center;\n\n    &:last-of-type {\n      border-top: 1px solid ", ";\n    }\n\n    &:hover {\n      background: ", ";\n      cursor: pointer;\n    }\n\n    &:active {\n      background: ", ";\n    }\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.controlColour;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.map.zoomControlInnerBorder;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.map.zoomControlInnerBorder;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.map.zoomControlHoverColor;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.map.zoomControlBorder;
});
ZoomControls.displayName = 'ZoomControls';
var MapZoomControls = function () {
    var map = react_leaflet_1.useLeaflet().map;
    var zoomOut = react_1.useCallback(function () {
        if (map)
            return map.zoomOut.call(map, 1);
        return lodash_1.default.identity;
    }, [map]);
    var zoomIn = react_1.useCallback(function () {
        if (map)
            return map.zoomIn.call(map, 1);
        return lodash_1.default.identity;
    }, [map]);
    return (react_1.default.createElement(ZoomControls, null,
        react_1.default.createElement(zoom_control_component_1.default, { onClick: zoomIn, icon: react_1.default.createElement(AddOutline_1.default, null) }),
        react_1.default.createElement(zoom_control_component_1.default, { onClick: zoomOut, icon: react_1.default.createElement(RemoveOutline_1.default, null) })));
};
MapZoomControls.displayName = 'MapZoomControls';
exports.default = MapZoomControls;
var templateObject_1;
//# sourceMappingURL=map-zoom-controls.component.js.map